<template>
    <div class="TQ_padding_8px">

        <div class="TQ_padding_8px TQ_margin_bottom_8px TQ_bg_purple_dark2 TQ_box_shadow TQ_grid_col_1frAuto">
            <div v-if="server_questExplore_c" class="TQ_grid_verticalCenter TQ_text_24px TQ_textColor_white">
                {{ ass_strings.twoWords_questEditor[store_system_langCode_v.val] }} - "{{server_questExplore_c.cm_qex_getName_fs(store_system_langCode_v.val)}}"
            </div>
            <tq-more-info class="TQ_width_32px TQ_grid_verticalCenter"
                          :p_img_e="enum_moreInfoImgOptions_e.ass_img_info2_w"
                          :p_more-info-id_uid="enum_moreInfo_helpersIds_s.helpers_edit_quest" />
        </div>

        <tq-loader-container class="TQ_center" :p_show-loader_b="showMainLoader || !server_questExplore_c || !server_questBody_c || !server_createdUserData_c" :p_tq-loader_b="true">
            <div v-if="!showMainLoader && server_questExplore_c && server_questBody_c && server_createdUserData_c">

                <!-- body -->
                <div class="TQ_grid_col_auto1fr TQ_grid_gap_8px">

                    <!-- nav bar  -->
                    <div class="TQ_bg_white TQ_minWidth_200px TQ_box_shadow TQ_text_20px TQ_align_initial ">

                        <!-- sections -->
                        <div v-for="(section_o, index_n) in co_sectionsTabs_ao" class="TQ_text_capitalize">

                            <!-- section name -->
                            <div class="TQ_padding_8px TQ_bg_purple_dark TQ_clickable TQ_grid_col_1frAuto TQ_border_bottom_white"
                                 @click="openSection_bySectionIndex_b[index_n] = !openSection_bySectionIndex_b[index_n]"
                                 v-if="section_o.sectionName_blc_s">
                                <div class="TQ_grid_verticalCenter">
                                    {{ section_o.sectionName_blc_s[store_system_langCode_v.val]}}
                                </div>
                                <tq-image :pb_src_r="openSection_bySectionIndex_b[index_n] ? ass_img_arrow_up_w : ass_img_arrow_down_w" class="TQ_width_20px TQ_grid_verticalCenter"/>
                            </div>

                            <!-- tabs -->
                            <div v-if="openSection_bySectionIndex_b[index_n]"
                                 v-for="tab_o in section_o.tabs_ao"
                                 @click="selectedTabId_n = tab_o.id_n"
                                 :class=" selectedTabId_n === tab_o.id_n && 'TQ_bg_gold'"
                                 class="TQ_padding_8px TQ_border_bottom TQ_clickable TQ_animation_show">
                                <tq-image :pb_src_r="tab_o.img_s" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                                <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                                <div class="TQ_inline TQ_verticalAlignMiddle">
                                    {{tab_o.name_blc_s[store_system_langCode_v.val]}}
                                </div>
                            </div>

                        </div>


                    </div>

                    <!-- body -->
                    <div class="TQ_bg_white TQ_box_shadow">

                        <!-- title -->
                        <div class="TQ_padding_8px  TQ_border_bottom TQ_align_initial TQ_text_capitalize TQ_grid_col_1frAuto">
                            <div class="TQ_grid_verticalCenter TQ_text_28px">
                                {{ co_selectedTab_o.name_blc_s[store_system_langCode_v.val] }}
                            </div>

                            <tq-more-info v-if="co_selectedTab_o.moreInfoId_e" class="TQ_width_28px TQ_grid_verticalCenter" :p_more-info-id_uid="co_selectedTab_o.moreInfoId_e" />

                        </div>

                        <!-- body -->
                        <div class="TQ_center TQ_padding_48px">

                            <!-- 0) overview-->
                            <div >

                                <c_-creator_-edit-quests_-item_-overview
                                    v-if="selectedTabId_n === 0"
                                    :p_system_lang-code_e="store_system_langCode_v.val"
                                    :p_created-user-data_c="server_createdUserData_c"
                                    :p_currency_e="store_system_currency_v.val"
                                    :p_quest-explore-info_c="server_questExploreInfo_c"
                                    :p_quest-explore_c="server_questExplore_c"
                                    :p_quest-reviews_ac="server_questReviews_ac"
                                    :p_user-data_by-user-id_c="server_userData_byUserId_c"
                                    :p_screen-size_en="store_system_windowSizeType_ve.val"
                                    :p_get-all-reviews_b="getAllReviews_b"
                                    :p_show-more-reviews-btn-loader_b="showMoreReviewsBtnLoader_b"
                                    :pe_reviews_get-next3_f="m_reviews_getNext3_f"
                                />


                            </div>

                            <!-- 1) intro -->
                            <div>

                                <!-- 10) Explore basic-->
                                <c_-creator_-edit-quests_-item_-explore-basic
                                    v-if="selectedTabId_n === 10"
                                    :p_store_system-lang-code_e="store_system_langCode_v.val"
                                    :p_quest-explore_c="server_questExplore_c"
                                    :p_creator-data_c="server_createdUserData_c"
                                    :p_quest-body_c="server_questBody_c"/>

                                <!-- 11) Explore gallery -->
                                <c_Creator_EditQuests_Item_ExploreGallery
                                    v-if="selectedTabId_n === 12"
                                    :store_system-lang-code="store_system_langCode_v.val"
                                    :pe_choose-file_f="(cb_f) => {m_showQuestFiles_f(cb_f, true, false, false)}"
                                    :quest-explore="server_questExplore_c"/>

                                <!-- 12) quest description -->
                                <c_-creator_-edit-quests_-item_-explore_-info
                                    v-if="selectedTabId_n === 11"
                                    pb_uid_s="Intro"
                                    :ps_lang-code_e="store_system_langCode_v.val"
                                    :pb_quest-explore_c="server_questExplore_c"
                                />

                                <!-- 13) intro video  -->
                                <c_-creator_-edit-quests_-item_intro-video class="TQ_padding_16px"
                                                                           :pe_choose-file_f="(cb_f) => {m_showQuestFiles_f(cb_f, false, true, false)}"
                                                                           v-if="selectedTabId_n === 13" :p_quest-explore_c="server_questExplore_c"/>

                                <!-- 14) available dates -->
                                <c_-creator_-edit-quests_-item_-explore_-available-dates
                                    v-if="selectedTabId_n === 14"
                                    :ps_lang-code_e="store_system_langCode_v.val"
                                    :pb_qex_available-dates_at="server_questExplore_c.qex_availableDates_at"
                                />

                                <!-- 15) pricing -->
                                <c_Creator_EditQuests_Item_ExploreTickets
                                    v-if="selectedTabId_n === 15"
                                    :p_qex_lang-arr_ae="server_questExplore_c.qex_langArr_ae"
                                    :p_qex_available-tickets_ac="server_questExplore_c.qex_availableTickets_ac"
                                    :p_system_lang-code_e="store_system_langCode_v.val"
                                    :p_system_currency_e="store_system_currency_ve.val"
                                    :p_qex_metadata_c="server_questExplore_c.qex_metadata_c"
                                />

                            </div>

                            <!-- 2) playing-->
                            <div>
                                <!-- 20) quest info -->
                                <c_-creator_-edit-quests_-item_-quest-body_-game-rules
                                    v-if="selectedTabId_n === 20"
                                    :key="refreshQuestBody_keyCounter_n"
                                    :p_system_lang-code_e="store_system_langCode_v.val"
                                    :p_supported-lang-codes_ae="server_questBody_c.qb_langArr_ae"
                                    :p_qb_game-rules_by-lang-code="server_questBody_c.qb_questRules_byLangCode_c"
                                    :pe_choose-file_f="m_showQuestFiles_f"
                                />

                                <!-- 21) list missions -->
                                <div v-if="selectedTabId_n === 21"
                                     :is="co_tabs_missionsList_ao.length > 1 ? 'tq-tabs' : 'div'"
                                     :p_tabs_ao="co_tabs_missionsList_ao"
                                     p_att_s="title_s"
                                     :p_selected-tab-index_vn="selectedTabIndex_editMissions_vn"
                                     p_tabs-class_s="TQ_padding_12px TQ_text_20px"
                                     class="TQ_minHeight_400px TQ_bg_white TQ_padding_4px">

                                    <c_Creator_EditQuests_Item_BodySideMissions
                                        v-if="co_tabs_editMap_ao[selectedTabIndex_editMissions_vn.val].id === 0"
                                        :key="refreshQuestBody_keyCounter_n"
                                        :p_qb_missions-groups_ac="server_questBody_c.qb_missionsGroup_ac"
                                        :p_qb_metadata_c="server_questBody_c.qb_metadata_c"
                                        :p_qb_side-missions_ac="server_questBody_c.qb_listMissions_ac"
                                        :p_qb_supported-lang-codes_ae="server_questBody_c.qb_langArr_ae"
                                        :p_qb_display-lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                                        :p_system_lang-code="store_system_langCode_v.val"
                                        :p_creator-active-payment-plan_b="co_activePaymentPlan_b"

                                        :pe_add-mission-riddle_f="(missionsGroupId_n) => {server_questBody_c.cm_qb_addSideMission_f(server_questBody_c.qb_missionsGroup_ac, server_questBody_c.qb_listMissions_ac, missionsGroupId_n)}"
                                        :pe_add-mission-group_f="() => {server_questBody_c.cm_qb_addMissionGroup_f(server_questBody_c.qb_missionsGroup_ac)}"
                                        :pe_reorder-missions_f="m_reorderMissionRiddles_f"
                                        :pe_choose-file_f="m_showQuestFiles_f"
                                    />

                                    <!-- 4) cards missions -->
                                    <c_Creator_EditQuests_Item_BodyCardsRiddles
                                        v-if="co_tabs_editMap_ao[selectedTabIndex_editMissions_vn.val].id === 1"
                                        p_uid_s="cardBodyMissions"
                                        :key="'listLastMissions' + refreshQuestBody_keyCounter_n"

                                        :lang-arr="server_questBody_c.qb_langArr_ae"
                                        :riddles="server_questBody_c.qb_listLastMissions_ac"
                                        :p_metadata-q-b_c="server_questBody_c.qb_metadata_c"
                                        :p_system_lang-code_e="store_system_langCode_v.val"
                                        :p_display_lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                                        :p_cards-missions_b="true"
                                        :pe_choose-file_f="m_showQuestFiles_f"
                                        :p_creator-active-payment-plan_b="co_activePaymentPlan_b"
                                    />


                                </div>

                                <!-- 22) cards missions -->
                                <c_Creator_EditQuests_Item_BodyCardsRiddles
                                    v-if="selectedTabId_n === 22"
                                    p_uid_s="cardBodyMissions"
                                    :key="'cardBodyMissions' + refreshQuestBody_keyCounter_n"

                                    :lang-arr="server_questBody_c.qb_langArr_ae"
                                    :riddles="server_questBody_c.qb_cardsMissions_ac"
                                    :p_metadata-q-b_c="server_questBody_c.qb_metadata_c"
                                    :p_system_lang-code_e="store_system_langCode_v.val"
                                    :p_display_lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                                    :p_cards-missions_b="true"
                                    :p_creator-active-payment-plan_b="co_activePaymentPlan_b"

                                    :pe_choose-file_f="m_showQuestFiles_f"
                                />

                                <!-- 23) edit map -->
                                <tq-tabs v-if="selectedTabId_n === 23"
                                         :p_tabs_ao="co_tabs_editMap_ao"
                                         p_att_s="title_s"
                                         :p_vertical-layout_b="true"
                                         :p_selected-tab-index_vn="selectedTabIndex_editMap_vn"
                                         p_tabs-class_s="TQ_padding_12px TQ_text_20px"
                                         class="TQ_minHeight_400px TQ_bg_white TQ_padding_4px">

                                    <!-- 5.1) quest map-->
                                    <c_Creator_EditQuests_Item_BodyMap
                                        v-if="co_tabs_editMap_ao[selectedTabIndex_editMap_vn.val].id === 0"
                                        :key="refreshQuestBody_keyCounter_n"
                                        :p_system_lang-code_e="store_system_langCode_v.val"
                                        :pe_choose-image_f="(cb_f) => {m_showQuestFiles_f(cb_f, true, false, false)}"
                                        :p_quest-body_c="server_questBody_c"/>

                                    <!-- 5.2) Quest Map Riddles-->
                                    <c_Creator_EditQuests_Item_BodyMapRiddles
                                        v-if="co_tabs_editMap_ao[selectedTabIndex_editMap_vn.val].id === 1"
                                        :key="refreshQuestBody_keyCounter_n"
                                        :p_quest-body_c="server_questBody_c"
                                        :p_system_lang-code_e="store_system_langCode_v.val"
                                        :p_creator-active-payment-plan_b="co_activePaymentPlan_b"
                                        :pe_choose-file_f="m_showQuestFiles_f"
                                    />

                                    <!-- 5.3) map last riddle -->
                                    <c_Creator_EditQuests_Item_BodyCardsRiddles
                                        v-if="co_tabs_editMap_ao[selectedTabIndex_editMap_vn.val].id === 2"
                                        p_uid_s="mapLastMissions"
                                        :key="refreshQuestBody_keyCounter_n"
                                        :lang-arr="server_questBody_c.qb_langArr_ae"
                                        :main-lang="server_questBody_c.qb_mainLang_e"
                                        :riddles="server_questBody_c.qb_mapLastMissions_ac"
                                        :p_system_lang-code_e="store_system_langCode_v.val"
                                        :p_display_lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                                        :p_metadata-q-b_c="server_questBody_c.qb_metadata_c"
                                        :p_creator-active-payment-plan_b="co_activePaymentPlan_b"
                                        :pe_choose-file_f="m_showQuestFiles_f"
                                    />
                                </tq-tabs>

                                <!-- 24) missions Arrangements -->
                                <c_-creator_-edit-quests_-item_-orders-missions
                                    v-if="selectedTabId_n === 24"
                                    :key="refreshQuestBody_keyCounter_n"
                                    :p_quest-body_c="server_questBody_c"
                                    :p_system_lang-code_e="store_system_langCode_v.val"/>

                                <!-- 25) Quest Codes -->
                                <c_Creator_EditQuests_Item_BodyCodes
                                    class="TQ_margin_8px"
                                    v-if="selectedTabId_n === 25"
                                    :key="refreshQuestBody_keyCounter_n"
                                    :p_qb_metadata_c="server_questBody_c.qb_metadata_c"
                                    :p_system_lang-code_e="store_system_langCode_v.val"
                                    :p_clues-codes_ac="server_questBody_c.qb_cluesCodes_ac"/>

                                <!-- 26) setting-->
                                <c_Creator_EditQuests_Item_BodyBasic
                                    v-if="selectedTabId_n === 26"
                                    :key="refreshQuestBody_keyCounter_n"
                                    :p_store_system-lang-code_e="store_system_langCode_v.val"
                                    :p_quest-body_c="server_questBody_c"
                                    :p_creator-data_c="server_createdUserData_c"
                                    :pe_choose-file_f="m_showQuestFiles_f"

                                />
                            </div>

                            <!-- 3) others -->
                            <div>
                                <!-- 30) other - creator terms  -->
                                <c_-creator_-edit-quests_-item_-explore_creator-terms
                                    v-if="selectedTabId_n === 30"
                                    :pb_uid_s="server_questExplore_c.qex_questId_uid"
                                    :pb_qex_lang-arr_ae="server_questExplore_c.qex_langArr_ae"
                                    :pb_creator-terms_blc_c="server_questExplore_c.qex_creatorTerms_byLangCode_c"
                                    :pe_choose-file_f="m_showQuestFiles_f"
                                />

                                <!-- 31) other - emails -->
                                <c_-creator_-edit-quests_-item_-explore_-emails
                                    v-if="selectedTabId_n === 31"
                                    pb_uid_s="Intro"
                                    :ps_lang-code_e="store_system_langCode_v.val"
                                    :pb_quest-explore_c="server_questExplore_c"
                                />

                                <!-- 32) other - permissions -->
                                <c_-creator_-edit-quests_-item_permissions
                                    v-if="selectedTabId_n === 32"
                                    :p_system-lang-code_e="store_system_langCode_v.val"
                                    :p_uds_quest-permissions_ac="server_uds_questPermissions_ac"
                                    :p_current-user_uds_quest-permission_c="server_currentUser_uds_questPermission_c"
                                    :p_user-data_by-user-id_c="server_userData_byUserId_c"
                                    :pe_set-quest-permission_f="m_setQuestPermission_f"
                                />

                                <!-- 33) Links -->
                                <div v-if="selectedTabId_n === 33" class="TQ_padding_8px">

                                    <!-- 33.1) store link -->
                                    <div class="TQ_center TQ_maxWidth_500px TQ_border TQ_inline TQ_verticalAlignTop TQ_borderRadius">
                                        <div class="TQ_bg_purple TQ_padding_12px TQ_margin_bottom_8px TQ_text_20px TQ_text_capitalize">
                                            {{ass_strings.twoWords_storeLink[store_system_langCode_v.val]}}
                                        </div>

                                        <div class="TQ_text_selectable TQ_direction_ltr TQ_borderRadius TQ_border TQ_box_shadow TQ_padding_8px TQ_align_initial TQ_text_14px TQ_margin_8px TQ_bg_gray4 TQ_selectable">
                                            {{co_storeLink_s}}
                                        </div>

                                        <div class="TQ_margin_bottom_8px">
                                            <div class="TQ_bg_gold TQ_textColor_white TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_inline TQ_center TQ_clickable" @click="m_copyStoreLink_f">
                                                <tq-image :pb_src_r="ass_img_copy_w" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_4px"/>
                                                <div class="TQ_inline TQ_padding_4px">{{ass_strings.oneWord_copy[store_system_langCode_v.val]}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- spacing -->
                                    <div class="TQ_padding_8px TQ_inline TQ_verticalAlignTop">
                                    </div>

                                    <!-- 33.2) embed link -->
                                    <div class="TQ_center TQ_maxWidth_500px TQ_border TQ_inline TQ_verticalAlignTop TQ_borderRadius">

                                        <div class="TQ_bg_purple TQ_padding_12px TQ_margin_bottom_8px TQ_text_20px TQ_text_capitalize">
                                            {{ass_strings.threeWords_embeddedStoreCode[store_system_langCode_v.val]}}
                                        </div>

                                        <div class="TQ_text_selectable TQ_direction_ltr TQ_borderRadius TQ_border TQ_box_shadow TQ_padding_8px TQ_align_initial TQ_text_14px TQ_margin_8px TQ_bg_gray4 TQ_selectable">
                                            {{co_embeddedIframe_s}}
                                        </div>

                                        <div class="TQ_margin_bottom_8px">
                                            <div class="TQ_bg_gold TQ_textColor_white TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_inline TQ_center TQ_clickable" @click="m_copyEmbeddedIframe_f">
                                                <tq-image :pb_src_r="ass_img_copy_w" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_4px"/>
                                                <div class="TQ_inline TQ_padding_4px">{{ass_strings.oneWord_copy[store_system_langCode_v.val]}}</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>

                                <!-- 45) discount coupons-->
                                <c_-creator_-edit-quests_-item_-discount-coupons
                                    :p_system-lang-code_e="store_system_langCode_v.val"
                                    :p_discount-coupons_by-coupon-id_c="server_discountCoupons_byCouponId_c"
                                    :p_creator-data_c="server_createdUserData_c"

                                    :pe_refresh-discount-coupons_f="m_refreshDiscountCoupons_f"
                                    :pe_create-new-discount-coupon_f="m_newDiscountCoupon_f"
                                    :pe_update-coupon-status_f="m_updateCouponStatus_f"

                                    v-if="selectedTabId_n === 34"/>

                                <!-- 35 backups -->
                                <div v-if="selectedTabId_n === 35">

                                    <div class="TQ_maxWidth_350px TQ_center TQ_padding_8px">

                                        <div @click="bodyBottomLoader_b || selectedBackupIndex_n === index_n ? selectedBackupIndex_n = null : selectedBackupIndex_n= index_n"
                                             :key="index_n"
                                             class="TQ_border TQ_margin_4px TQ_borderRadius TQ_bg_hover_goldLite TQ_clickable"
                                             v-for="(questVersionInfo_c, index_n) in server_questBackupInfo_ac">

                                            <!-- title -->
                                            <div class="TQ_padding_8px">

                                                <tq-textarea
                                                    @click.native.stop=""
                                                    v-if="selectedBackupIndex_n === index_n"
                                                    :key="server_questBackupInfo_ac[selectedBackupIndex_n].qbi_questBackupId_uid"
                                                    pb_uid_s="fullName"
                                                    pb_textarea-class_s="TQ_center TQ_padding_4px TQ_text_20px"
                                                    :pb_init-text_s="questVersionInfo_c.qbi_name_s"
                                                    :pb_max-length_n="20"
                                                    pb_placeholder_s="version name"
                                                    :pb_rows_n="1"
                                                    :pe_change-text_s="(text_s) => {questVersionInfo_c.qbi_name_s = text_s}"
                                                />
                                                <div v-else class="TQ_text_bold TQ_text_20px" >{{questVersionInfo_c.qbi_name_s}}</div>

                                                <div class="TQ_text_14px" v-if="questVersionInfo_c.qbi_savedDate_t">( {{format_date_YYYY_MM_DD_hh_mm_fs(questVersionInfo_c.qbi_savedDate_t)}} )</div>
                                            </div>

                                            <!-- btns -->
                                            <div v-if="selectedBackupIndex_n === index_n"
                                                 class="TQ_grid_col_autoAuto TQ_text_16px TQ_padding_8px TQ_border_top ">

                                                <!-- load backup -->
                                                <tq-btn-approve
                                                    class="TQ_inline"
                                                    :approve-cb="m_loadBackup_f"
                                                    :popup-text="ass_strings.question_loadBackupQuest"
                                                    :system-lang-code="store_system_langCode_v.val">
                                                    <div class="TQ_btn TQ_bg_gold TQ_borderRadius TQ_text_capitalize TQ_textColor_white">
                                                        {{ass_strings.twoWords_loadBackup[store_system_langCode_v.val]}}
                                                    </div>
                                                </tq-btn-approve>

                                                <!-- save as new backup -->
                                                <tq-btn-approve
                                                    class="TQ_inline"
                                                    :approve-cb="m_saveBackup_f"
                                                    :popup-text="ass_strings.question_saveBackupQuest"
                                                    :system-lang-code="store_system_langCode_v.val">
                                                    <div class="TQ_btn TQ_bg_green TQ_borderRadius TQ_text_capitalize">
                                                        {{ass_strings.twoWords_saveBackup[store_system_langCode_v.val]}}
                                                    </div>
                                                </tq-btn-approve>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>

                            <!-- bottom loader -->
                            <tq-loader-container :p_show-loader_b="bodyBottomLoader_b"></tq-loader-container>

                        </div>

                    </div>

                </div>

                <!-- save button -->
                <div class="TQ_bottom_fixed " v-if="co_questExploreChanged_b || co_questBodyChange_b">
                    <tq-loader-button :show-loader="showBtnLoader">
                        <div class="TQ_margin_8px TQ_bg_white TQ_bg_purple TQ_padding_4px TQ_borderRadius TQ_box_shadow2" @click="m_save_f()">
                            <tq-beacon :p_show-beacon_b="true" class="TQ_verticalAlignMiddle TQ_inline">
                                <img :src="ass_img_save_w" class="TQ_width_16px TQ_margin_4px"/>
                            </tq-beacon>
                            <div class="TQ_text_24px TQ_inline TQ_verticalAlignMiddle TQ_margin_4px">{{ass_strings.oneWord_save[store_system_langCode_v.val]}}</div>
                        </div>
                    </tq-loader-button>
                </div>

                <!-- popup exit edit quest -->
                <tq-popup :show="beforeLeaving_showPopup_vb"
                          width="100%"
                          maxWidth="350px"
                          padding="0px"
                          class="TQ_center"
                          :show-close-btn="true">

                    <div class="TQ_text_24px TQ_text_bold TQ_bg_purple_dark TQ_padding_8px">{{ass_strings.threeWords_exitEditQuest[store_system_langCode_v.val]}}</div>

                    <div class="TQ_text_16px TQ_padding_8px TQ_margin_8px_0">{{ass_strings.question_exitEditQuest[store_system_langCode_v.val]}}</div>

                    <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_border_top">
                        <div class="TQ_box_shadow TQ_bg_gray3 TQ_borderRadius TQ_width_72px TQ_padding_8px TQ_clickable" @click="beforeLeaving_showPopup_vb.val = false">
                            {{ass_strings.oneWord_cancel[store_system_langCode_v.val]}}
                        </div>
                        <div></div>
                        <div class="TQ_box_shadow TQ_bg_purple TQ_borderRadius TQ_width_72px TQ_padding_8px TQ_clickable" @click="beforeLeaving_exitCb_f()">
                            {{ass_strings.oneWord_approve[store_system_langCode_v.val]}}
                        </div>
                    </div>

                </tq-popup>

                <!-- choose file -->
                <tq-popup :show="popup_chooseFile_show_vb" width="100%" p_height_s="100vh" class="TQ_center" padding="0" :show-close-btn="true">
                    <fcuc-drive
                        :p_can-choose-image_b="popup_chooseFile_chooseImage_b"
                        :p_can-choose-video_b="popup_chooseFile_chooseVideo_b"
                        :p_can-choose-audio_b="popup_chooseFile_chooseAudio_b"
                        :pe_choose-file_f="m_chooseFile_f"
                    />
                </tq-popup>

            </div>
        </tq-loader-container>

    </div>
</template>

<script>

    import TqLoaderButton from "../../../components/basic2/TqLoaderButton";
    import TqCard from "../../../components/basic/TqCard";
    import TqToggleDiv from "../../../components/basic/TqToggleDiv";
    import {
        serverBig_questBody_once_fp,
        serverBig_questExplore_once_f,
        serverBig_questBody_update_f,
        serverBig_questExplore_update_f, serverBig_questBody_backup_set_f, serverBig_questBody_backup_get_f,
    } from "@/scripts/Server/S_ServerFirestore";
    import TqTabs from "../../../components/basic/TqTabs";
    import {
        enum_arrangeMissionsType_s,
        enum_fbPath,
        enum_availableTicketsTypes_s,
        enum_questPermission_n,
        enum_moreInfo_helpersIds_s,
        enum_moveToOptions,
        enum_urlParams,
        enum_featuresMinPoints,
        enum_moreInfo_featuresIds_s, enum_questLocationsTypes_s, enum_moreInfoImgOptions_e, enum_hiddenCodesTypes
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {obj_deepCopy_f, obj_equals_fb,} from "../../../../functions/src/shareCode/Share_S_Obj";
    import {store_var, store_getStateValue_vo} from "@/store";

    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {notification_notify, notification_notify2} from "@/scripts/S_Notification";

    import c_Creator_EditQuests_Item_ExploreBasic from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_ExploreBasic";
    import c_Creator_EditQuests_Item_ExploreGallery from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_ExploreGallery";
    import c_Creator_EditQuests_Item_ExploreTickets from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_ExploreTickets";

    import c_Creator_EditQuests_Item_BodyBasic from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_BodyBasic";
    import c_Creator_EditQuests_Item_BodyMap from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_BodyMap";
    import c_Creator_EditQuests_Item_BodyMapRiddles from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_BodyMapRiddles";
    import c_Creator_EditQuests_Item_BodyCodes from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_BodyCodes";
    import c_Creator_EditQuests_Item_BodySideMissions from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_MissionsGroups";
    import c_Creator_EditQuests_Item_BodyCardsRiddles from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_BodyCardsRiddles";
    import C_Creator_EditQuests_Item_QuestBody_GameRules from "./v_Creator_EditQuet_Item/C_Creator_EditQuests_Item_QuestBody_GameRules";

    import TqQuestExploreHeader from "../../../components/complex/TqQuestExploreHeader";
    import {
        server_admin_createNewQuestDiscountCoupons_f,
        server_discountCoupons_getAll_f,
        server_discountCoupons_new_f,
        server_discountCoupons_update_f,
        server_getQuestExploreInfo_f,
        server_questBackupsInfo_getOnce_fp,
        server_questGeoHash_getOnce_fp, server_questGeoHash_update_fp,
        server_questReviews_get_last3_f,
        serverPre_moreInfo_get_one_f, serverPre_subUserData_subscriptionPlanInfo_get_f,
        serverPre_userDataSub_questPermission_get_withQuestId_f,
        serverPre_userDataSub_questPermission_set_f,
    } from "@/scripts/Server/S_ServerPre";
    import {
        helper_copyStringToClipboard
    } from "@/scripts/S_Helper";
    import {
        ass_img_arrow_down_w, ass_img_arrow_up_w, ass_img_bulletsList_b,
        ass_img_bulletsList_p,
        ass_img_bulletsList_w, ass_img_calendar_b,
        ass_img_calendar_p,
        ass_img_calendar_w, ass_img_cards_b,
        ass_img_cards_p,
        ass_img_cards_w,
        ass_img_cloud_backup_down_arrow_b,
        ass_img_cloud_backup_up_arrow_b, ass_img_copy_w, ass_img_copyLink_b, ass_img_coupon_b, ass_img_document_b,
        ass_img_document_p,
        ass_img_document_w, ass_img_edit2_b,
        ass_img_edit_p,
        ass_img_edit_w, ass_img_embedded_w, ass_img_gallery_b,
        ass_img_gallery_p,
        ass_img_gallery_w, ass_img_home_b, ass_img_idea_b,
        ass_img_idea_p,
        ass_img_idea_w, ass_img_info_b,
        ass_img_info_p,
        ass_img_info_w, ass_img_link_w, ass_img_mail_b, ass_img_mail_p, ass_img_mail_w, ass_img_map_b,
        ass_img_map_p,
        ass_img_map_w, ass_img_priceTag_b,
        ass_img_puzzle2_p,
        ass_img_puzzle2_w, ass_img_puzzlePiece_b,
        ass_img_puzzlePiece_p,
        ass_img_puzzlePiece_w, ass_img_reviews_b, ass_img_reviews_w,
        ass_img_save_w, ass_img_settingsGear_b,
        ass_img_settingsGear_p,
        ass_img_settingsGear_w, ass_img_svg_key_b, ass_img_svg_key_p, ass_img_svg_key_w,
        ass_img_ticket4_p,
        ass_img_ticket4_w,
        ass_img_tickets_b, ass_img_tos_b,
        ass_img_tos_p,
        ass_img_tos_w, ass_img_video_b,
        ass_img_video_p,
        ass_img_video_w, ass_img_videoPlayer,
    } from "@/assets/scripts/Ass_Files";
    import {route_getUrlData_fo} from "@/router";
    import C_Creator_EditQuests_Item_Explore_AvailableDates
        from "./v_Creator_EditQuet_Item/C_Creator_EditQuests_Item_Explore_AvailableDates";
    import C_Creator_EditQuests_Item_Explore_Info
        from "./v_Creator_EditQuet_Item/C_Creator_EditQuests_Item_Explore_Info";
    import C_Creator_EditQuests_Item_Explore_creatorTerms
        from "./v_Creator_EditQuet_Item/C_Creator_EditQuests_Item_Explore_creatorTerms";
    import {
        FB_QuestBackupInfo,
        FB_QuestBody,
        FB_QuestExplore,
        FB_QuestExplore_GeoHash, FB_QuestPointer,
        FB_SlideData
    } from "../../../../functions/src/shareCode/Share_S_Classes";
    import TqPopup from "../../../components/basic/TqPopup";
    import TqBtnApprove from "../../../components/basic2/TqBtnApprove";
    import TqTextarea from "../../../components/basic/TqTextarea";
    import TqDropdown from "../../../components/basic/TqDropdown";
    import {format_date_YYYY_MM_DD_hh_mm_fs, format_langCode_fs} from "../../../../functions/src/shareCode/Share_S_Format";
    import TqToggleSwitch from "../../../components/basic/TqToggleSwitch";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f, serverAuth_getOtherUserData_f
    } from "@/scripts/Server/S_ServerAuth";
    import C_Creator_EditQuests_Item_OrdersMissions
        from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_OrdersMissions";
    import fcucDrive from "../../../components/unpure/FcucDrive";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqDisplayFile from "../../../components/mediaComponenets/TqDisplayFile";
    import C_Creator_EditQuests_Item_Explore_Emails
        from "./v_Creator_EditQuet_Item/C_Creator_EditQuests_Item_Explore_emails";
    import C_Creator_EditQuests_Item_permissions from "./v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_permissions";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import TqImage from "@/components/basic/TqImage";
    import {gv_urls} from "@/scripts/S_GlobalVar";
    import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
    import TqBeacon from "@/components/basic2/TqBeacon";
    import C_Creator_EditQuests_Item_Overview
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_Overview";
    import C_Creator_EditQuests_Item_introVideo
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_introVideo";
    import C_Creator_EditQuests_Item_DiscountCoupons
        from "@/views/v_Creator/v_Creator_EditQuests/v_Creator_EditQuet_Item/c_Creator_EditQuests_Item_DiscountCoupons";
    import {map_geoHash_encode_fp} from "@/scripts/API/S_Map";
    import {helper_getObjIndexInArray_fn} from "../../../../functions/src/shareCode/Share_S_Helper";

    export default {
        name: "v_creator_editQuest_item",
        components: {
            C_Creator_EditQuests_Item_DiscountCoupons,
            C_Creator_EditQuests_Item_introVideo,
            C_Creator_EditQuests_Item_Overview,
            TqBeacon,
            TqOnTopContainer,
            TqImage,
            TqMoreInfo,
            C_Creator_EditQuests_Item_permissions,
            C_Creator_EditQuests_Item_Explore_Emails,

            C_Creator_EditQuests_Item_OrdersMissions,
            C_Creator_EditQuests_Item_Explore_creatorTerms,
            C_Creator_EditQuests_Item_Explore_Info,
            C_Creator_EditQuests_Item_Explore_AvailableDates,
            C_Creator_EditQuests_Item_QuestBody_GameRules,
            c_Creator_EditQuests_Item_ExploreBasic,
            c_Creator_EditQuests_Item_ExploreGallery,
            c_Creator_EditQuests_Item_ExploreTickets,
            c_Creator_EditQuests_Item_BodyBasic,
            c_Creator_EditQuests_Item_BodyCardsRiddles,
            c_Creator_EditQuests_Item_BodyMap,
            c_Creator_EditQuests_Item_BodyMapRiddles,
            c_Creator_EditQuests_Item_BodyCodes,
            c_Creator_EditQuests_Item_BodySideMissions,

            TqDisplayFile,
            TqLoaderContainer,
            fcucDrive,
            TqToggleSwitch,
            TqDropdown,
            TqTextarea,
            TqBtnApprove,
            TqPopup,
            TqTabs,
            TqToggleDiv,
            TqCard,
            TqLoaderButton,
            TqQuestExploreHeader,
        },
        data(){
            return {

                selectedTabId_n                         : 0,
                openSection_bySectionIndex_b            : {0 : true, 1 : true, 2 : true, 3 : true},

                selectedTabIndex_cardsMissionType_vn    : {val: 0},
                selectedTabIndex_editMap_vn             : {val: 0},
                selectedTabIndex_editMissions_vn        : {val: 0},

                selectedBackupIndex_n : null,
                bodyBottomLoader_b    : false,

                // reviews
                showMoreReviewsBtnLoader_b      : false,
                getAllReviews_b                 : false,
                reviewLastTimestamp_t           : null,

                popup_chooseFile_show_vb        : {val : undefined},
                popup_chooseFile_chooseImage_b  : true,
                popup_chooseFile_chooseVideo_b  : true,
                popup_chooseFile_chooseAudio_b  : true,
                popup_chooseFile_cb_f           : null,

                beforeLeaving_exitCb_f     : () => {},
                beforeLeaving_showPopup_vb : {val : false},
                saveVersion_showPopup_vb : {val : false},
                loadVersion_showPopup_vb : {val : false},

                refreshQuestBody_keyCounter_n: 0,

                showBtnLoader: false,
                showMainLoader: false,

                // store
                store_system_langCode_v         : store_getStateValue_vo(store_var.system_langCode),
                store_system_currency_ve        : store_getStateValue_vo(store_var.system_currency),
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_system_currency_v         : store_getStateValue_vo(store_var.system_currency),

                // server
                server_questExploreInfo_c           : undefined,
                server_questExplore_c               : undefined,
                server_questBody_c                  : undefined,
                server_questGeoHash_c               : undefined,
                server_createdUserData_c            : undefined,
                server_creator_uds_subPlanInfo_c    : undefined,
                server_currentUserData_c            : undefined,
                server_questBackupInfo_ac           : undefined,
                server_uds_questPermissions_ac      : [],
                server_userData_byUserId_c          : {},
                server_currentUser_uds_questPermission_c   : null,
                server_questReviews_ac              : [],
                server_discountCoupons_byCouponId_c   : undefined,

                oldQuestBody                : undefined,
                oldQuestExplore             : undefined,


                // imports
                ass_strings                         : ass_strings,
                enum_availableTicketsTypes_s        : enum_availableTicketsTypes_s,
                enum_moreInfo_helpersIds_s          : enum_moreInfo_helpersIds_s,
                enum_moreInfoImgOptions_e           : enum_moreInfoImgOptions_e,
                ass_img_link_w                      : ass_img_link_w,
                ass_img_embedded_w                  : ass_img_embedded_w,
                ass_img_copy_w                      : ass_img_copy_w,
                ass_img_save_w                      : ass_img_save_w,
                ass_img_videoPlayer                 : ass_img_videoPlayer,
                ass_img_arrow_down_w                : ass_img_arrow_down_w,
                ass_img_arrow_up_w                  : ass_img_arrow_up_w,
                format_date_YYYY_MM_DD_hh_mm_fs     : format_date_YYYY_MM_DD_hh_mm_fs,
                format_langCode_fs                  : format_langCode_fs,
            }
        },
        computed:{
            co_haveCreatorPermission_b(){

                if(this.server_currentUser_uds_questPermission_c == null){
                    return false
                }
                return this.server_currentUser_uds_questPermission_c.udsqp_permission_n >= enum_questPermission_n.owner
            },

            co_questExploreChanged_b(){
                return JSON.stringify(this.oldQuestExplore) !== JSON.stringify(this.server_questExplore_c)
            },
            co_questBodyChange_b(){
                return JSON.stringify(this.oldQuestBody) !== JSON.stringify(this.server_questBody_c)
            },

            co_tabs_missionsList_ao(){

                let tabs_ao= [];

                // 4) list missions
                tabs_ao.push({title_s : ass_strings.oneWord_missions[this.store_system_langCode_v.val],     id: 0, img_s: ass_img_edit_p, imgSelected_s: ass_img_edit_w})

                // list last missions
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportListLastMissions_b){
                    tabs_ao.push({title_s: ass_strings.twoWords_lastMissions[this.store_system_langCode_v.val],    id: 1, img_s: ass_img_puzzle2_p, imgSelected_s: ass_img_puzzle2_w})
                }

                return tabs_ao
            },
            co_tabs_editMap_ao(){

                let tabs_ao= [];

                // 4) map missions
                tabs_ao.push({title_s : ass_strings.twoWords_editMap[this.store_system_langCode_v.val],     id: 0, img_s: ass_img_edit_p, imgSelected_s: ass_img_edit_w})
                tabs_ao.push({title_s : ass_strings.twoWords_mapMissions[this.store_system_langCode_v.val], id: 1, img_s: ass_img_puzzlePiece_p, imgSelected_s: ass_img_puzzlePiece_w})

                // map last missions
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapLastMissions_b){
                    tabs_ao.push({title_s: ass_strings.threeWords_mapLastMissions[this.store_system_langCode_v.val],    id: 2, img_s: ass_img_puzzle2_p, imgSelected_s: ass_img_puzzle2_w})
                }

                return tabs_ao
            },

            co_sectionsTabs_ao(){

                return [
                    {
                        tabs_ao: [
                            {name_blc_s: ass_strings.oneWord_overview,      id_n: 0,      img_s : ass_img_home_b},
                        ],
                    },
                    {
                        sectionName_blc_s: ass_strings.oneWord_introduction,
                        tabs_ao: [
                            {name_blc_s: ass_strings.twoWords_basicInfo,      id_n: 10,    img_s : ass_img_edit2_b,     moreInfoId_e : enum_moreInfo_helpersIds_s.helpers_edit_intro_basicInfo},
                            {name_blc_s: ass_strings.twoWords_photosGallery,  id_n: 12,    img_s : ass_img_gallery_b,  },
                            {name_blc_s: ass_strings.oneWord_description,     id_n: 11,    img_s : ass_img_document_b},
                            {name_blc_s: ass_strings.oneWord_video,           id_n: 13,    img_s : ass_img_video_b},

                            this.server_questExplore_c.qex_metadata_c.qexm_playerChooseEvent_b &&
                            {name_blc_s: ass_strings.twoWords_questAvailability, id_n: 14,    img_s : ass_img_calendar_b},

                            this.co_haveCreatorPermission_b &&
                            {name_blc_s: ass_strings.oneWord_pricing,         id_n: 15,    img_s : ass_img_priceTag_b, moreInfoId_e : enum_moreInfo_helpersIds_s.helpers_edit_intro_pricing},
                        ].filter(item => {return item !== false}),
                    },
                    {
                        sectionName_blc_s: ass_strings.oneWord_quest,
                        tabs_ao: [
                            {name_blc_s: ass_strings.oneWord_rules,     id_n: 20,         img_s : ass_img_info_b},
                            this.server_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b &&

                            {name_blc_s: ass_strings.twoWords_missionsList,   id_n: 21,   img_s : ass_img_bulletsList_b},

                            this.server_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b &&
                            {name_blc_s: ass_strings.twoWords_cardsMissions,   id_n: 22,    img_s : ass_img_cards_b, moreInfoId_e : enum_moreInfo_helpersIds_s.helpers_edit_quest_cardMissions},

                            this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b &&
                            {name_blc_s: ass_strings.twoWords_mapMissions,   id_n: 23,     img_s : ass_img_map_b},

                            this.server_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e !== enum_arrangeMissionsType_s.none &&
                            {name_blc_s: ass_strings.twoWords_orderMissions,   id_n: 24,  img_s : ass_img_puzzlePiece_b},

                            this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b &&
                            {name_blc_s: ass_strings.twoWords_hintCodes,   id_n: 25,   img_s : ass_img_idea_b},

                            {name_blc_s: ass_strings.oneWord_settings,        id_n: 26,    img_s : ass_img_settingsGear_b},
                        ].filter(item => {return item !== false}),
                    },
                    {
                        sectionName_blc_s: ass_strings.oneWord_other,
                        tabs_ao: [
                            {name_blc_s: ass_strings.twoWords_creatorTerms,      id_n: 30,   img_s : ass_img_tos_b},
                            {name_blc_s: ass_strings.oneWord_email,              id_n: 31,   img_s : ass_img_mail_b},

                            {name_blc_s: ass_strings.oneWord_permissions,        id_n: 32,   img_s : ass_img_svg_key_b,     moreInfoId_e : enum_moreInfo_helpersIds_s.helpers_edit_permission},
                            {name_blc_s: ass_strings.oneWord_Link,               id_n: 33,   img_s : ass_img_copyLink_b,    moreInfoId_e : enum_moreInfo_helpersIds_s.helpers_edit_quest_links},

                            {name_blc_s: ass_strings.twoWords_discountCoupon,    id_n: 34,   img_s : ass_img_coupon_b,      },
                            {name_blc_s: ass_strings.oneWord_backup,             id_n: 35,   img_s : ass_img_cloud_backup_down_arrow_b},

                        ].filter(item => {return item !== false}),
                    },
                ]
            },
            co_selectedTab_o(){

                for(let sectionIndex_n in this.co_sectionsTabs_ao){
                    let section_o = this.co_sectionsTabs_ao[sectionIndex_n]
                    for(let tabIndex_n in section_o.tabs_ao){
                        let tab_o = section_o.tabs_ao[tabIndex_n]
                        if (tab_o.id_n ===  this.selectedTabId_n){
                            return tab_o
                        }
                    }
                }
                return {}

            },

            co_storeLink_s(){

                if(this.server_questExplore_c == null){
                    return ''
                }
                
                return `${gv_urls.tq_basicUrl}/${this.store_system_langCode_v.val}/${enum_moveToOptions.player_store_quest.substring(1)}/${this.server_questExplore_c.qex_questId_uid}`
            },
            co_embeddedIframe_s(){

                if(this.server_questExplore_c == null){
                    return ''
                }

                const path = `${gv_urls.tq_basicUrl}/${this.store_system_langCode_v.val}/${enum_moveToOptions.player_store_whiteLabel.substring(1)}?${enum_urlParams.questId}=${this.server_questExplore_c.qex_questId_uid}`
                return `<iframe src="${path}" width="400px" height="670"  frameBorder="0" border-radius: 5px"></iframe>`
            },
            co_activePaymentPlan_b(){
                if(this.server_creator_uds_subPlanInfo_c){
                    return this.server_creator_uds_subPlanInfo_c.udsspi_m_activePaymentPlan_b()
                }
                return false
            }

        },
        methods:{

            m_copyStoreLink_f(){
                helper_copyStringToClipboard(this.co_storeLink_s)
                notification_notify2({title_s: ass_strings.threeWords_copiedToClipboard[this.store_system_langCode_v.val]})
            },
            m_copyEmbeddedIframe_f(){
                helper_copyStringToClipboard(this.co_embeddedIframe_s)
                notification_notify2({title_s: ass_strings.threeWords_copiedToClipboard[this.store_system_langCode_v.val]})
            },

            m_save_f(){

                if(!this.co_questExploreChanged_b && !this.co_questBodyChange_b){
                    notification_notify(ass_strings.twoWords_noChanges)
                    return
                }

                this.showBtnLoader = true

                // 2) update quest explore
                if(this.co_questExploreChanged_b){
                    serverBig_questExplore_update_f(this.server_questExplore_c, () => {
                        this.oldQuestExplore = JSON.parse(JSON.stringify(this.server_questExplore_c))
                        this.showBtnLoader = false
                        notification_notify(ass_strings.oneWord_updated)
                    })

                }

                // 3) update quest body
                if(this.co_questBodyChange_b){

                    serverBig_questBody_update_f(this.server_questBody_c, ()=>{

                        this.oldQuestBody = new FB_QuestBody(obj_deepCopy_f(this.server_questBody_c))
                        this.showBtnLoader = false
                        notification_notify(ass_strings.oneWord_updated)
                    })
                }

                // 4) update geoHash
                if(this.co_questExploreChanged_b){

                    let newGeoHash_c = null

                    if(this.server_questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocationsTypes_s.outside){
                        let startingLocation_c = this.server_questExplore_c.qex_startingLocationPoint_c
                        newGeoHash_c = new FB_QuestExplore_GeoHash({
                            qg_questId_uid      : this.server_questExplore_c.qex_questId_uid,
                            qg_geoHash_s        : map_geoHash_encode_fp(startingLocation_c.mp_lat_n,startingLocation_c.mp_lng_n),
                            qg_startingLocation_c: startingLocation_c,
                            qg_questName_blc_s  : this.server_questExplore_c.qex_name_byLangCode_s,
                            qg_langArr_ae       : this.server_questExplore_c.qex_langArr_ae,
                            qg_mainLang_e       : this.server_questExplore_c.qex_mainLang_e,
                            qg_overallRating_n  : this.server_questGeoHash_c ? this.server_questGeoHash_c.qg_overallRating_n : null,
                        })
                    }

                    server_questGeoHash_update_fp(this.server_questExplore_c.qex_questId_uid, newGeoHash_c)
                }


            },
            m_reorderMissionRiddles_f(new_qb_missionRiddles_ac, qbgm_groupMissionId_n){

                if(this.server_questBody_c.qb_metadata_c.qbm_listMissions_supportMissionsGroups_b){

                    let index_n = helper_getObjIndexInArray_fn(this.server_questBody_c.qb_missionsGroup_ac, enum_fbPath.qbmg_missionsGroupId_n, qbgm_groupMissionId_n)

                    this.server_questBody_c.qb_missionsGroup_ac[index_n].qbmg_riddlesIds_an = new_qb_missionRiddles_ac.map(qb_riddle_c => {return qb_riddle_c.qbr_riddleId_n})

                }else{
                    this.server_questBody_c.qb_listMissions_ac = new_qb_missionRiddles_ac
                }

            },
            m_setQuestPermission_f(userId_uid, questPermission_n, cb_f){

                serverPre_userDataSub_questPermission_set_f({
                    questId_uid         : this.server_questExplore_c.qex_questId_uid,
                    questType_e         : this.server_questExplore_c.qex_questType_e,
                    userId_uid          : userId_uid,
                    permissionLevel_n   : questPermission_n,
                    cb_f: (uds_questPermission_c) => {

                        let index = this.server_uds_questPermissions_ac.map(uds_questPermission_c => uds_questPermission_c.udsqp_userId_uid).indexOf(uds_questPermission_c.udsqp_userId_uid)
                        if(index>=0){
                            this.server_uds_questPermissions_ac.splice(index, 1, uds_questPermission_c)
                        }else{
                            this.server_uds_questPermissions_ac.push(uds_questPermission_c)
                        }


                        notification_notify2({title_s: ass_strings.oneWord_updated})
                        cb_f(uds_questPermission_c)
                    },
                })

            },

            m_saveBackup_f(){
                this.bodyBottomLoader_b = true
                let selectedQuestBackupInfo_c = this.server_questBackupInfo_ac[this.selectedBackupIndex_n]
                this.selectedBackupIndex_n = null
                serverBig_questBody_backup_set_f(this.server_questBody_c, selectedQuestBackupInfo_c, this.server_currentUserData_c.ud_userId_uid,
                    () => {
                        this.bodyBottomLoader_b = false
                        notification_notify(ass_strings.oneWord_saved)
                    })
            },
            m_loadBackup_f(){
                this.bodyBottomLoader_b = true
                let selectedQuestBackupInfo_c = this.server_questBackupInfo_ac[this.selectedBackupIndex_n]
                this.selectedBackupIndex_n = null
                serverBig_questBody_backup_get_f(selectedQuestBackupInfo_c,
                    (questBody_c) =>{
                        this.bodyBottomLoader_b = false

                        this.refreshQuestBody_keyCounter_n ++

                        notification_notify(ass_strings.twoWords_loadedBackup)
                        this.server_questBody_c = questBody_c;

                    })
            },

            // quest files
            m_chooseFile_f(file_c){
                this.popup_chooseFile_show_vb.val = false
                this.popup_chooseFile_cb_f(file_c)
            },
            m_showQuestFiles_f(cb_f, chooseImage_b=true, chooseVideo_b=true, chooseAudio_b=true){
                this.popup_chooseFile_show_vb.val = true
                this.popup_chooseFile_chooseImage_b = chooseImage_b
                this.popup_chooseFile_chooseVideo_b = chooseVideo_b
                this.popup_chooseFile_chooseAudio_b = chooseAudio_b
                this.popup_chooseFile_cb_f = cb_f
            },

            // get data from server
            m_activated_questPermissions_get_f(){

                if(this.server_questExplore_c == null || this.server_currentUserData_c == null){
                    return
                }

                this.server_uds_questPermissions_ac = []
                serverPre_userDataSub_questPermission_get_withQuestId_f({
                    questType_e: this.server_questExplore_c.qex_questType_e,
                    questId_uid: this.server_questExplore_c.qex_questId_uid,
                    cb_f : (uds_questPermissions_ac) => {

                        this.server_uds_questPermissions_ac = uds_questPermissions_ac

                        uds_questPermissions_ac.forEach(uds_questPermission_c => {
                            serverAuth_getOtherUserData_f(uds_questPermission_c.udsqp_userId_uid, (userData_c) => {

                                this.$set(this.server_userData_byUserId_c, uds_questPermission_c.udsqp_userId_uid, userData_c)

                                // currentUser questPermission
                                if(uds_questPermission_c.udsqp_userId_uid === this.server_currentUserData_c.ud_userId_uid){
                                    this.server_currentUser_uds_questPermission_c = uds_questPermission_c
                                }

                            })
                        })
                    }
                })
            },
            m_reviews_getNext3_f(){

                server_questReviews_get_last3_f(this.server_questExplore_c.qex_questType_e, this.server_questExplore_c.qex_questId_uid, this.reviewLastTimestamp_t,
                    (questReview_ac,lastTimestamp_t) => {

                        this.showMoreReviewsBtnLoader_b = false

                        if(lastTimestamp_t == null){
                            this.getAllReviews_b = true
                            return
                        }

                        this.server_questReviews_ac = this.server_questReviews_ac.concat(questReview_ac)
                        this.reviewLastTimestamp_t = lastTimestamp_t

                        questReview_ac.forEach(questReview_c => {
                            serverAuth_getOtherUserData_f(questReview_c.qr_reviewerId_uid, (userData_c) => {
                                if(userData_c)
                                    this.$set(this.server_userData_byUserId_c, userData_c.ud_userId_uid, userData_c)
                            })
                        })
                    })
            },

            // discount coupons
            m_refreshDiscountCoupons_f(){
                server_discountCoupons_getAll_f(this.server_questExplore_c.qex_questType_e, this.server_questExplore_c.qex_questId_uid, (discountCoupons_byCouponId_c) => {
                    this.server_discountCoupons_byCouponId_c = discountCoupons_byCouponId_c
                })
            },
            m_newDiscountCoupon_f(couponCode_s, discountPercentage_n, cb_f){
                server_discountCoupons_new_f(this.server_questExplore_c.qex_questType_e, this.server_questExplore_c.qex_questId_uid, couponCode_s, discountPercentage_n, cb_f)
            },
            m_updateCouponStatus_f(questDiscountCoupon_c, cb_f){
                server_discountCoupons_update_f(questDiscountCoupon_c, cb_f)
            }


        },

        // life circle
        activated(){


            this.server_questBody_c = null;
            this.showMainLoader = true
            this.selectedTabId_n = 0;
            this.beforeLeaving_showPopup_vb.val = false
            this.server_questReviews_ac = []
            this.reviewLastTimestamp_t = null

            let route_questPointer_c  = new FB_QuestPointer(route_getUrlData_fo(this.$route))


            // 0) get quest geoHash
            server_questGeoHash_getOnce_fp(route_questPointer_c.qp_questId_uid, (questGeoHash_c) => {
                this.server_questGeoHash_c = questGeoHash_c
            })

            // 1) get quest explore
            serverBig_questExplore_once_f(route_questPointer_c.qp_questId_uid, false, 
                (questExplore_c) =>{
                    this.server_questExplore_c = questExplore_c
                    this.oldQuestExplore = new FB_QuestExplore(obj_deepCopy_f(this.server_questExplore_c))

                    serverAuth_getOtherUserData_f(this.server_questExplore_c.qex_creatorId_uid,
                        userData_c =>{
                            this.server_createdUserData_c = userData_c;
                        })

                    serverPre_subUserData_subscriptionPlanInfo_get_f({
                        userId_uid: this.server_questExplore_c.qex_creatorId_uid,
                        cb_f: (uds_subPlanInfo_c) => {
                            this.server_creator_uds_subPlanInfo_c = uds_subPlanInfo_c;
                        }
                    })

                    server_getQuestExploreInfo_f(this.server_questExplore_c, (questExploreInfo_c) => {
                        this.server_questExploreInfo_c = questExploreInfo_c
                    })

                    this.m_activated_questPermissions_get_f()

                    // get next 3 reviews
                    this.m_reviews_getNext3_f()
                })

            // 2) get quest body
            serverBig_questBody_once_fp(route_questPointer_c.qp_questType_e, route_questPointer_c.qp_questId_uid, true, false, questBody_c => {
                this.server_questBody_c = questBody_c

                this.oldQuestBody = JSON.parse(JSON.stringify(questBody_c))
                this.showMainLoader = false

                // this.server_questBody_c.qb_mapMissions_ac = this.server_questBody_c.qb_listMissions_ac
                // console.log(this.server_questBody_c.qb_missionsGroup_ac)

                // this.server_questBody_c.qb_missionsGroup_ac[0].qbmg_riddlesIds_an = this.server_questBody_c.qb_missionsGroup_ac[0].qbmg_riddlesIds_an.concat(this.server_questBody_c.qb_missionsGroup_ac[2].qbmg_riddlesIds_an)
                // this.server_questBody_c.qb_missionsGroup_ac[1].qbmg_riddlesIds_an = this.server_questBody_c.qb_missionsGroup_ac[1].qbmg_riddlesIds_an.concat(this.server_questBody_c.qb_missionsGroup_ac[3].qbmg_riddlesIds_an)
                // this.server_questBody_c.qb_missionsGroup_ac.splice(3,1)
                // this.server_questBody_c.qb_missionsGroup_ac.splice(2,1)

                // this.server_questBody_c.qb_missionsGroup_ac[1].qbmg_riddlesIds_an = [3,4,5]
                // this.server_questBody_c.qb_missionsGroup_ac[2].qbmg_riddlesIds_an = [6,7,8]
                // this.server_questBody_c.qb_missionsGroup_ac[3].qbmg_riddlesIds_an = [9,10,11]
                // this.server_questBody_c.qb_missionsGroup_ac[4].qbmg_riddlesIds_an = [12,13,14]
                // this.server_questBody_c.qb_missionsGroup_ac[5].qbmg_riddlesIds_an = []
                // this.server_questBody_c.qb_missionsGroup_ac[6].qbmg_riddlesIds_an = []

            })


            // 3) get current userData
            serverAuth_currentUserData_get_vl_fp(this.$options.name , (userData_c) => {

                if(userData_c == null){
                    return
                }

                this.server_currentUserData_c = userData_c

                this.m_activated_questPermissions_get_f()

                // 4) get backupsInfo
                server_questBackupsInfo_getOnce_fp(route_questPointer_c.qp_questType_e, route_questPointer_c.qp_questId_uid, (questVersionInfo_ac) => {

                    questVersionInfo_ac.sort((questBackupInfo1_c, questBackupInfo2_c) => {
                        return questBackupInfo1_c.qbi_savedDate_t - questBackupInfo2_c.qbi_savedDate_t})

                    this.server_questBackupInfo_ac = questVersionInfo_ac

                    while(this.server_questBackupInfo_ac.length < 3){
                        this.server_questBackupInfo_ac.push(new FB_QuestBackupInfo({
                            qbi_questType_e         : route_questPointer_c.qp_questType_e,
                            qbi_questId_uid         : route_questPointer_c.qp_questId_uid,
                            qbi_name_s              : "Quest Backup " + (this.server_questBackupInfo_ac.length + 1),
                            qbi_savedDate_t         : null,
                            qbi_savedByPlayerId_uid : userData_c.ud_userId_uid,
                            qbi_questBackupId_uid  : null,
                        }))
                    }


                })

            })

        },
        deactivated(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        },
        beforeRouteLeave(to, from, next){

            if(!this.co_questExploreChanged_b && !this.co_questBodyChange_b){
                next()
                return
            }

            this.beforeLeaving_showPopup_vb.val = true
            this.beforeLeaving_exitCb_f = () => {
                this.beforeLeaving_exitCb_f =  ()=>{}
                next()
            }

        }

    };

</script>

<style scoped lang="scss">

</style>